// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/VerbenPage/VerbenPage.css */

.verben-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding-bottom: calc(var(--space-2xl) + 60px);
  position: relative;
  min-height: 60vh;
}

/* ---- Header ---- */
.verben-page__header {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.verben-page__title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.verben-page__title-icon {
  font-size: var(--font-size-xl);
}

.verben-page__subtitle {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

/* ---- Generation Section ---- */
.verben-generation {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.verben-generation__title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-md);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.verben-generation__section {
  margin-bottom: var(--space-md);
}

.verben-generation__section-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: var(--space-sm);
}

/* ---- Chip Selectors ---- */
.verben-chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-xs);
}

.verben-chip {
  padding: var(--space-xs) var(--space-md);
  border-radius: var(--radius-full);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.verben-chip:active {
  transform: scale(0.96);
}

.verben-chip--selected {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
}

.verben-chip--disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.verben-chip--disabled::after {
  content: ' (Demnächst)';
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-normal);
}

/* ---- Preview ---- */
.verben-preview {
  background-color: rgba(139, 94, 60, 0.06);
  border: 1.5px solid var(--color-wood-light);
  border-radius: var(--radius-md);
  padding: var(--space-sm) var(--space-md);
  text-align: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-wood-dark);
  margin-bottom: var(--space-md);
}

.verben-preview__count {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-wood-medium);
}

/* ---- Generate Button ---- */
.verben-generate-btn {
  width: 100%;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  border: none;
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  box-shadow: var(--shadow-md);
}

.verben-generate-btn:active {
  background-color: var(--color-wood-dark);
  transform: scale(0.98);
}

.verben-generate-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ---- Success Message ---- */
.verben-success {
  background-color: rgba(76, 175, 80, 0.1);
  border: 1.5px solid var(--color-success);
  border-radius: var(--radius-md);
  padding: var(--space-sm) var(--space-md);
  text-align: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-success);
  animation: verben-success-fade 4s ease-out forwards;
}

@keyframes verben-success-fade {
  0% { opacity: 0; transform: translateY(4px); }
  10% { opacity: 1; transform: translateY(0); }
  80% { opacity: 1; }
  100% { opacity: 0; }
}

/* ---- Progress Indicator ---- */
.verben-progress {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm) var(--space-md);
  background-color: rgba(139, 94, 60, 0.06);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  color: var(--color-wood-dark);
  font-weight: var(--font-weight-semibold);
}

.verben-progress__icon {
  font-size: var(--font-size-lg);
}

/* ---- Search Bar ---- */
.verben-search {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: var(--space-sm);
}

.verben-search__input {
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  padding-left: calc(var(--space-md) + 24px);
  padding-right: var(--space-xl);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-full);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  appearance: none;
}

.verben-search__input:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.verben-search__input::placeholder {
  color: var(--color-text-light);
}

.verben-search__icon {
  position: absolute;
  left: var(--space-md);
  font-size: var(--font-size-sm);
  color: var(--color-text-light);
  pointer-events: none;
  line-height: 1;
}

.verben-search__clear {
  position: absolute;
  right: var(--space-sm);
  width: 28px;
  height: 28px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--color-text-light);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  padding: 0;
}

.verben-search__clear:hover,
.verben-search__clear:active {
  background-color: var(--color-progress-bg);
  color: var(--color-text-primary);
}

.verben-search__result-count {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  text-align: right;
  padding: 0 var(--space-xs);
  margin-bottom: var(--space-xs);
}

/* ---- Filter Bar ---- */
.verben-filter-bar {
  display: flex;
  gap: var(--space-xs);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: var(--space-xs) 0;
}

.verben-filter-bar::-webkit-scrollbar {
  display: none;
}

.verben-filter-btn {
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-full);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}

.verben-filter-btn--active {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
}

/* ---- Verb Card Table ---- */
.verben-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.verben-table thead {
  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);
}

.verben-table th {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-dark);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
}

.verben-table th:first-child {
  text-align: center;
  width: 40px;
}

.verben-table th:last-child {
  text-align: center;
  width: 80px;
}

.verben-table td {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
  word-break: break-word;
}

.verben-table tbody tr:last-child td {
  border-bottom: none;
}

.verben-table tbody tr:nth-child(even) {
  background-color: rgba(245, 239, 230, 0.4);
}

/* ---- Empty State ---- */
.verben-page__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl) var(--space-md);
  gap: var(--space-md);
  text-align: center;
  color: var(--color-text-secondary);
}

.verben-page__empty-icon {
  font-size: 2.5rem;
}

.verben-page__empty-text {
  font-size: var(--font-size-sm);
  max-width: 280px;
  line-height: var(--line-height-normal);
}

/* ---- Duplicate Warning Dialog ---- */
.verben-duplicate-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
}

.verben-duplicate-dialog {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 340px;
  padding: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  text-align: center;
}

.verben-duplicate-dialog__icon {
  font-size: 2.5rem;
}

.verben-duplicate-dialog__message {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  line-height: var(--line-height-normal);
}

.verben-duplicate-dialog__actions {
  display: flex;
  gap: var(--space-sm);
}

.verben-duplicate-dialog__btn {
  flex: 1 1;
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
}

.verben-duplicate-dialog__btn--cancel {
  background-color: var(--color-progress-bg);
  color: var(--color-text-secondary);
}

.verben-duplicate-dialog__btn--confirm {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
}

/* Reuse vokabeln page styles for info/action cells */
.verben-table__info-cell {
  text-align: center;
  position: relative;
}

.verben-table__action-cell {
  text-align: center;
  white-space: nowrap;
}

/* Reuse FAB styles */
.verben-fab {
  position: fixed;
  bottom: calc(var(--bottom-nav-height) + var(--space-lg));
  right: var(--space-lg);
  z-index: 90;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-full);
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border: none;
  box-shadow: 0 4px 12px rgba(92, 58, 30, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.verben-fab:active {
  transform: scale(0.92);
}

.verben-fab__icon {
  font-size: 1.75rem;
  font-weight: var(--font-weight-bold);
  line-height: 1;
}

@media (min-width: 481px) {
  .verben-fab {
    right: calc(50% - var(--max-content-width) / 2 + var(--space-lg));
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/VerbenPage/VerbenPage.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,+BAA+B;EAC/B,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,wCAAwC;EACxC,wCAAwC;EACxC,+BAA+B;EAC/B,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,KAAK,UAAU,EAAE,0BAA0B,EAAE;EAC7C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,0CAA0C;EAC1C,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,kFAAkF;EAElF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;;EAEE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,gCAAgC;EAChC,4CAA4C;EAC5C,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,wDAAwD;EACxD,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,gCAAgC;EAChC,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,iEAAiE;EACnE;AACF","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/VerbenPage/VerbenPage.css */\n\n.verben-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  padding-bottom: calc(var(--space-2xl) + 60px);\n  position: relative;\n  min-height: 60vh;\n}\n\n/* ---- Header ---- */\n.verben-page__header {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.verben-page__title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.verben-page__title-icon {\n  font-size: var(--font-size-xl);\n}\n\n.verben-page__subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n/* ---- Generation Section ---- */\n.verben-generation {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.verben-generation__title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-md);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.verben-generation__section {\n  margin-bottom: var(--space-md);\n}\n\n.verben-generation__section-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: var(--space-sm);\n}\n\n/* ---- Chip Selectors ---- */\n.verben-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-xs);\n}\n\n.verben-chip {\n  padding: var(--space-xs) var(--space-md);\n  border-radius: var(--radius-full);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.verben-chip:active {\n  transform: scale(0.96);\n}\n\n.verben-chip--selected {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n}\n\n.verben-chip--disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.verben-chip--disabled::after {\n  content: ' (Demnächst)';\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-normal);\n}\n\n/* ---- Preview ---- */\n.verben-preview {\n  background-color: rgba(139, 94, 60, 0.06);\n  border: 1.5px solid var(--color-wood-light);\n  border-radius: var(--radius-md);\n  padding: var(--space-sm) var(--space-md);\n  text-align: center;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-wood-dark);\n  margin-bottom: var(--space-md);\n}\n\n.verben-preview__count {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-wood-medium);\n}\n\n/* ---- Generate Button ---- */\n.verben-generate-btn {\n  width: 100%;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  border: none;\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  box-shadow: var(--shadow-md);\n}\n\n.verben-generate-btn:active {\n  background-color: var(--color-wood-dark);\n  transform: scale(0.98);\n}\n\n.verben-generate-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ---- Success Message ---- */\n.verben-success {\n  background-color: rgba(76, 175, 80, 0.1);\n  border: 1.5px solid var(--color-success);\n  border-radius: var(--radius-md);\n  padding: var(--space-sm) var(--space-md);\n  text-align: center;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-success);\n  animation: verben-success-fade 4s ease-out forwards;\n}\n\n@keyframes verben-success-fade {\n  0% { opacity: 0; transform: translateY(4px); }\n  10% { opacity: 1; transform: translateY(0); }\n  80% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\n/* ---- Progress Indicator ---- */\n.verben-progress {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-sm) var(--space-md);\n  background-color: rgba(139, 94, 60, 0.06);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  color: var(--color-wood-dark);\n  font-weight: var(--font-weight-semibold);\n}\n\n.verben-progress__icon {\n  font-size: var(--font-size-lg);\n}\n\n/* ---- Search Bar ---- */\n.verben-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--space-sm);\n}\n\n.verben-search__input {\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  padding-left: calc(var(--space-md) + 24px);\n  padding-right: var(--space-xl);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.verben-search__input:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.verben-search__input::placeholder {\n  color: var(--color-text-light);\n}\n\n.verben-search__icon {\n  position: absolute;\n  left: var(--space-md);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-light);\n  pointer-events: none;\n  line-height: 1;\n}\n\n.verben-search__clear {\n  position: absolute;\n  right: var(--space-sm);\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--color-text-light);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  padding: 0;\n}\n\n.verben-search__clear:hover,\n.verben-search__clear:active {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-primary);\n}\n\n.verben-search__result-count {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  text-align: right;\n  padding: 0 var(--space-xs);\n  margin-bottom: var(--space-xs);\n}\n\n/* ---- Filter Bar ---- */\n.verben-filter-bar {\n  display: flex;\n  gap: var(--space-xs);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  padding: var(--space-xs) 0;\n}\n\n.verben-filter-bar::-webkit-scrollbar {\n  display: none;\n}\n\n.verben-filter-btn {\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-full);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.verben-filter-btn--active {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n}\n\n/* ---- Verb Card Table ---- */\n.verben-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n}\n\n.verben-table thead {\n  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);\n}\n\n.verben-table th {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-dark);\n  text-align: left;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n}\n\n.verben-table th:first-child {\n  text-align: center;\n  width: 40px;\n}\n\n.verben-table th:last-child {\n  text-align: center;\n  width: 80px;\n}\n\n.verben-table td {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n  word-break: break-word;\n}\n\n.verben-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.verben-table tbody tr:nth-child(even) {\n  background-color: rgba(245, 239, 230, 0.4);\n}\n\n/* ---- Empty State ---- */\n.verben-page__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-xl) var(--space-md);\n  gap: var(--space-md);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.verben-page__empty-icon {\n  font-size: 2.5rem;\n}\n\n.verben-page__empty-text {\n  font-size: var(--font-size-sm);\n  max-width: 280px;\n  line-height: var(--line-height-normal);\n}\n\n/* ---- Duplicate Warning Dialog ---- */\n.verben-duplicate-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-md);\n}\n\n.verben-duplicate-dialog {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 340px;\n  padding: var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  text-align: center;\n}\n\n.verben-duplicate-dialog__icon {\n  font-size: 2.5rem;\n}\n\n.verben-duplicate-dialog__message {\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  line-height: var(--line-height-normal);\n}\n\n.verben-duplicate-dialog__actions {\n  display: flex;\n  gap: var(--space-sm);\n}\n\n.verben-duplicate-dialog__btn {\n  flex: 1;\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n}\n\n.verben-duplicate-dialog__btn--cancel {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-secondary);\n}\n\n.verben-duplicate-dialog__btn--confirm {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n}\n\n/* Reuse vokabeln page styles for info/action cells */\n.verben-table__info-cell {\n  text-align: center;\n  position: relative;\n}\n\n.verben-table__action-cell {\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* Reuse FAB styles */\n.verben-fab {\n  position: fixed;\n  bottom: calc(var(--bottom-nav-height) + var(--space-lg));\n  right: var(--space-lg);\n  z-index: 90;\n  width: 56px;\n  height: 56px;\n  border-radius: var(--radius-full);\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border: none;\n  box-shadow: 0 4px 12px rgba(92, 58, 30, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.verben-fab:active {\n  transform: scale(0.92);\n}\n\n.verben-fab__icon {\n  font-size: 1.75rem;\n  font-weight: var(--font-weight-bold);\n  line-height: 1;\n}\n\n@media (min-width: 481px) {\n  .verben-fab {\n    right: calc(50% - var(--max-content-width) / 2 + var(--space-lg));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
